module.exports = __webpack_public_path__ + "img/gx.ffc3703a.png";